import { EventTracker } from "../EventTracker";

declare global {
  interface Window {
    pendo?: {
      isReady: () => boolean;
      updateOptions: (params: Record<string, unknown>) => void;
      initialize: (params: Record<string, unknown>) => void;
      showGuideById: (guideId: string) => void;
      track: (eventName: string, metadata?: Record<string, unknown>) => void;
    };
  }
}

/**
 * PendoEventTracker
 *
 * Implementation of EventTracker interface for Pendo analytics.
 * Wraps window.pendo.track() calls with safety checks.
 */
export class PendoEventTracker implements EventTracker {
  track(eventName: string, data: Record<string, unknown>): void {
    try {
      if (!window.pendo) {
        console.warn("Pendo is not available. Event not tracked:", eventName);
        return;
      }

      if (!window.pendo.isReady()) {
        console.warn("Pendo is not ready. Event not tracked:", eventName);
        return;
      }

      window.pendo.track(eventName, data);
    } catch (error) {
      console.error("Error tracking event with Pendo:", error);
    }
  }

  isReady(): boolean {
    return !!window.pendo && window.pendo.isReady();
  }
}
